import { app } from '../firebase/firebase-config';

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getAuth, updatePassword, updateEmail, reauthenticateWithCredential } from 'firebase/auth';
import * as yup from 'yup';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import options from '../dropdown/Services.js';
import { MultiSelect } from 'react-multi-select-component';
import './adminDashboard.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import UserModals from '../pages/userModals';
// import { userSchema as schema } from './s4chema.js';
import '../../bootstrap/dist/css/bootstrap.min.css';
import ConfirmationModal from '../account/tabs/ConfirmationModal';


const auth = getAuth(app);
const AdminDashboard = () => {
    const [userDetails, setUserDetails] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            console.log(user);
            if (user != null) {
                axios.get(`${process.env.REACT_APP_API_BASE_URL}/users`).then((response) => {
                    for (const i of response.data) {
                        if (i.email.toLowerCase() === user.email.toLowerCase()) {
                            setUserDetails(i);
                            break;
                        }
                    }
                    setLoading(false);
                });
            } else {
                alert("You appear to not logged in yet. PLease log in to use admin privilege.")
                window.location.assign("/login");
            }
        });
    }, []);

    return (
        <Dashboard userDetails={userDetails}></Dashboard>
    );
};

const Dashboard = ({ userDetails }) => {
    return (
        <>
            <h1>Admin Dashboard</h1>
            <Header></Header>
        </>
    );
};

const Header = () => {
    return (
        <Container>
            <Row >
                <Col>
                    <Card style={{ width: '18rem' }}>
                        <Card.Body>
                            <Card.Title>Users</Card.Title>
                            <Card.Text>
                                Examine the users who sign up
                            </Card.Text>

                            <button className="tile-button" onClick={() => {
                                window.location.assign("/adminUsers");
                            }}><h4>Click here to view users</h4></button>

                            <button className="tile-button" onClick={() => {
                                window.location.assign("/admin-account-search");
                            }}><h4>Click here to manage users</h4></button>
                        </Card.Body>
                    </Card>
                </Col>

                <Col >
                    <Card style={{ width: '18rem' }}>
                        <Card.Body>
                            <Card.Title>Services</Card.Title>
                            <Card.Text>
                                Examine the services offered.
                            </Card.Text>
                            <button className="tile-button" onClick={() => {
                                window.location.assign('/editServices');
                            }}><h4>Click here</h4></button>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

const EditServices = () => {
    const [services, setServices] = useState([{}]);
    const [deleteModal, setDeleteModal] = useState({ isOpen: false, itemId: null, itemName: '' });

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/services`)
            .then(response => {
                console.log(response);
                setServices(response.data);
            })
            .catch(err => {
                alert("Issue with fetching services in admin");
            });
    }, []);

    const handleDeleteService = async (serviceId) => {
        try {
            await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/services/` + serviceId);
            window.location.reload();
        } catch (err) {
            alert("Something wrong with deleting service: " + err);
        }
    };

    const openDeleteModal = (serviceId, serviceName) => {
        setDeleteModal({
            isOpen: true,
            itemId: serviceId,
            itemName: serviceName
        });
    };

    const closeDeleteModal = () => {
        setDeleteModal({
            isOpen: false,
            itemId: null,
            itemName: ''
        });
    };

    const confirmDelete = () => {
        if (deleteModal.itemId) {
            handleDeleteService(deleteModal.itemId);
        }
    };

    return (
        <>
            <ConfirmationModal
                isOpen={deleteModal.isOpen}
                onClose={closeDeleteModal}
                onConfirm={confirmDelete}
                title="Delete Service"
                message={`Are you sure you want to delete "${deleteModal.itemName}"? This action cannot be undone and will permanently remove the service from the system.`}
                confirmText="Delete Service"
                cancelText="Cancel"
                type="danger"
            />

            <button style={{ backgroundColor: "#9D96B8" }} onClick={() => {
                window.location.assign('/admin');
            }}>Go back to dashboard</button>
            <h3>Edit Services</h3>
            <ServicesTable services={services} onDeleteService={openDeleteModal} />
        </>
    );
};

const ServicesTable = ({ services, onDeleteService }) => {
    return (
        <>
            <table>
                <thead>
                    <tr>
                        <th>Service Name</th>
                        <th>Duration</th>
                        <th>Status</th>
                        <th>Actions</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    {services.map(service => {
                        return (
                            <tr key={service.id}>
                                <td>{service.name}</td>
                                <td>{service.duration}</td>
                                {service.enabled ? (
                                    <>
                                        <td>Enabled</td>
                                        <td>
                                            <button onClick={() => {
                                                axios.put(`${process.env.REACT_APP_API_BASE_URL}/services/` + service.id, { enabled: false })
                                                    .then(response => {
                                                        window.location.reload();
                                                    })
                                                    .catch(err => {
                                                        alert("Something wrong with disabling this service: " + err);
                                                    });
                                            }}>
                                                Disable
                                            </button>
                                        </td>
                                    </>
                                ) : (
                                    <>
                                        <td>Disabled</td>
                                        <td>
                                            <button onClick={() => {
                                                axios.put(`${process.env.REACT_APP_API_BASE_URL}/services/` + service.id, { enabled: true })
                                                    .then(response => {
                                                        window.location.reload();
                                                    })
                                                    .catch(err => {
                                                        alert("Something wrong with enabling this service: " + err);
                                                    });
                                            }}>
                                                Enable
                                            </button>
                                        </td>
                                    </>
                                )}
                                <td>
                                    <button onClick={() => onDeleteService(service.id, service.name)}>
                                        Delete service
                                    </button>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </>
    );
};

const AdminUsers = () => {
    const [users, setUsers] = useState([{}]);
    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/users`)
            .then(response => {
                setUsers(response.data);
            })
            .catch(err => {
                alert("Something wrong with grabbing the users");
            });
    }, []);
    return (
        <UsersList users={users} ></UsersList>
    );
};

const UsersList = ({ users }) => {
    const [show, setShow] = useState(false);
    const [showList, setShowList] = useState([]);
    const handleOpen = () => {
        setShow(true);
    };

    const handleClose = () => {
        setShow(false);
    };

    var tempArray = [];
    //initializing the showList variable
    const initializer = () => {
        users.forEach(() => {
            tempArray.push(false);
        });
    };

    return (
        <>
            <button style={{ backgroundColor: "#9D96B8" }} onClick={() => {
                window.location.assign('/admin');
            }}>Go back to dashboard</button>
            <h3>User Lists</h3>
            <Row className="m-6">
                {users.map(user => (
                    <Col xs lg={4} key={user.id}>
                        <Card className="col" style={{ width: '18rem' }}>
                            <Card.Body>
                                <Card.Title>{user.firstname + " " + user.lastname}</Card.Title>
                                <Card.Text>
                                    {user.account === 1 ? <p>Role: Healer</p> : (user.account === 2 ? <p>Role: Admin</p> : <p>Role: Client</p>)}
                                </Card.Text>
                                <Card.Text></Card.Text>
                                <button className="tile-button" onClick={() => {
                                    initializer();
                                    tempArray[parseInt(user.id) - 1] = true;
                                    setShowList([...tempArray]);
                                    handleOpen();
                                }}><h4>View more</h4></button>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
            <UserModals show={show} users={users} showList={showList} handleClose={handleClose} ></UserModals>
        </>
    );
};

export { AdminDashboard, EditServices, AdminUsers };